import React from 'react';
import { Box, Grid, Stack, Typography, Chip } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WorkIcon from '@mui/icons-material/Work';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Section, InfoField, COLORS } from '../ViewPatientDialog.utils';

export default function CaregiversTab({ patient }) {
  const aidants = patient.aidants || [];

  return (
    <Section icon={<SupervisorAccountIcon />} title="Aidants du patient" subtitle="Personnes ressources et aidants associés au patient">
      {aidants.length > 0 ? (
        <Grid container spacing={2}>
          {aidants.map((aidant) => (
            <Grid item xs={12} md={6} key={aidant.id_aidant}>
              <Box sx={{ p: 2.5, border: '1px solid', borderColor: 'divider', borderRadius: 2, backgroundColor: '#FFFFFF', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <Box>
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={1.5}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 800, color: COLORS.text }}>
                      {aidant.prenom_aidant} {aidant.nom_aidant}
                    </Typography>
                    <Stack direction="row" spacing={1}>
                      {aidant.pivot?.est_principal === 1 && (
                        <Chip label="Principal" size="small" sx={{ backgroundColor: COLORS.successBg, color: COLORS.success, fontWeight: 700 }} />
                      )}
                      {aidant.pivot?.lien_patient_aidant && (
                        <Chip label={aidant.pivot.lien_patient_aidant} size="small" sx={{ backgroundColor: COLORS.primarySoft, color: COLORS.primary, fontWeight: 700 }} />
                      )}
                    </Stack>
                  </Stack>
                  <Grid container spacing={1.5}>
                    <InfoField label="Téléphone" value={aidant.telephone_aidant} icon={<PhoneIcon fontSize="small" />} />
                    <InfoField label="Email" value={aidant.email_aidant} icon={<EmailIcon fontSize="small" />} />
                    <InfoField label="Profession" value={aidant.profession_aidant} icon={<WorkIcon fontSize="small" />} />
                    <InfoField label="Adresse" value={`${aidant.adresse_aidant || ''} ${aidant.ville_aidant || ''}`.trim()} icon={<LocationOnIcon fontSize="small" />} />
                    {aidant.pivot?.notes && (
                      <Grid item xs={12}>
                        <Typography variant="caption" sx={{ color: COLORS.muted, fontWeight: 700, display: 'block', mt: 1 }}>Notes de liaison:</Typography>
                        <Typography variant="body2" sx={{ color: COLORS.text, mt: 0.5 }}>{aidant.pivot.notes}</Typography>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box sx={{ py: 4, textAlign: 'center' }}>
          <Typography sx={{ color: COLORS.muted, fontStyle: 'italic' }}>Aucun aidant enregistré pour ce patient.</Typography>
        </Box>
      )}
    </Section>
  );
}